module.exports = __webpack_public_path__ + "static/img/vip@2x.8fb48f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/vip@2x.png
// module id = GqSL
// module chunks = 1